import { apiRequest } from "./ApiUtility";


export const getAutocompleteSuggestions = async (auth, query, tags, pageSize, pageNumber) => {
    const url = "/api/suggested-text/getsuggestions";
        const requestData = {
            query: query.trim(),
            tags,
            pageSize,
            pageNumber
        };
    return await apiRequest("post", url, auth, requestData);
};

